import { render } from "./InitPassword.vue?vue&type=template&id=107b2a6c"
import script from "./InitPassword.vue?vue&type=script&lang=js"
export * from "./InitPassword.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__